var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResourcePackService } from 'service/ResourcePackService';
import { take } from 'rxjs/operators';
import { ErrorHandlerService } from 'service/ErrorHandlerService';
import { DocumentService } from 'service/DocumentService';
import { saveAs } from 'file-saver';
var ResourcePackDocumentsComponent = /** @class */ (function () {
    function ResourcePackDocumentsComponent(route, service, errorHandler, documentService) {
        this.route = route;
        this.service = service;
        this.errorHandler = errorHandler;
        this.documentService = documentService;
        this.updating = false;
    }
    ResourcePackDocumentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.pipe(take(1)).subscribe(function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!params.id) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.loadResourcePack(params.id).toPromise()];
                    case 1:
                        _a.resourcePack = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    ResourcePackDocumentsComponent.prototype.loadResourcePack = function (resourcePackId) {
        return this.service.fetchById(resourcePackId);
    };
    ResourcePackDocumentsComponent.prototype.updateName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updating = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.service.updateName(this.resourcePack.id, this.resourcePack.name).toPromise()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.errorHandler.handleHttpError(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.updating = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ResourcePackDocumentsComponent.prototype.addNewDocumentToResourcePack = function (document) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.service.attachDocument(this.resourcePack.id, document).toPromise()];
                    case 1:
                        result = _a.sent();
                        this.resourcePack.documents.push(result);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.errorHandler.handleHttpError(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ResourcePackDocumentsComponent.prototype.deleteDocument = function (document) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm('Are you sure you want to delete ' + document.path + '?')) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.service.deleteDocument(document.id).toPromise()];
                    case 2:
                        _a.sent();
                        // remove document from list.
                        this.resourcePack.documents = this.resourcePack.documents.filter(function (doc) { return doc.id !== document.id; });
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this.errorHandler.handleHttpError(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ResourcePackDocumentsComponent.prototype.download = function (doc) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.documentService.downloadDocument(doc.document.id).subscribe(function (data) {
                    saveAs(data, doc.document.fileName);
                }, function (error) { return _this.errorHandler.handleHttpError(error); });
                return [2 /*return*/];
            });
        });
    };
    return ResourcePackDocumentsComponent;
}());
export { ResourcePackDocumentsComponent };
